import React from "react";
import { useTranslation } from "react-i18next";
import { StoreType } from "../../../types/modules/admin/storeType.type";
import StoreTypeItem from "./StoreTypeItem";
import { PermissionGate } from "../PermissionGate";
import { PermissionsKey } from "../../../data/permissions";

interface Props {
  types: StoreType[];
}

const StoreTypesTable: React.FC<Props> = ({ types }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal capitalize">{t("id")}</th>
            <th className="p-3 font-normal capitalize">{t("image")}</th>
            <th className="p-3 font-normal capitalize">{t("name_in_english")}</th>
            <th className="p-3 font-normal capitalize">{t("name_in_arabic")}</th>
            <PermissionGate permissions={[PermissionsKey.ViewTypeOfStore]}>
                <th className="p-3 font-normal capitalize">{t("sub_types")}</th>
            </PermissionGate>
            <PermissionGate permissions={[PermissionsKey.UpdateTypeOfStore, PermissionsKey.DeleteTypeOfStore]}>
              <th className="p-3 font-normal capitalize">{t("actions")}</th>
            </PermissionGate>
          </tr>
        </thead>
        <tbody className="text-sm">
          {types.map((type, index) => (
            <tr
              key={type.id}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
                <StoreTypeItem type={type}/>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default StoreTypesTable;